import React from "react";
import { Box } from "@mui/material";
import { InputControl } from "../../../shared/components/InputControl";

export const CreateOrEditStockTag = (props) => {
  const { tagName, onChange } = props;

  return (
    <Box
      sx={{
        paddingTop: "8px",
        padding: "20px",
        paddingBottom: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "16px",
      }}
    >
      <InputControl
        type="text"
        onChange={onChange}
        label="Tag Name"
        value={tagName}
        fullWidth
        required
      />
    </Box>
  );
};
